import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { Metamodel } from 'app/model/base/model';
import { FormatTypeCopySource } from './format-type.copysource';
import { OrcDataset } from 'app/model/dataset/orc.dataset';

@Metamodel.model({
    name: adfModelTypeMap.orc.copySourceType,
    display: [],
    tags: { datasetModel : [Metamodel.modelFor(OrcDataset)]}
})
export class OrcCopySource extends FormatTypeCopySource {
}
